// utils/logout.js
import { signOut } from 'aws-amplify/auth';

export const performLogout = async () => {
  try {
    // Sign out from AWS Cognito
    await signOut();
    
    // Clear all localStorage items related to user session
    localStorage.removeItem('user');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('selectedBusinessId');
    localStorage.removeItem('selectedBusinessName');
    localStorage.removeItem('fetch_user_check');
    
    // Clear any other app-specific data you might have stored
    // localStorage.removeItem('authToken');
    // localStorage.removeItem('refreshToken');
    
    console.log('User successfully logged out');
    
    return { success: true };
    
  } catch (error) {
    console.error('Error during logout:', error);
    
    // Even if signOut fails, clear localStorage
    // This handles cases where the session might be expired
    localStorage.removeItem('user');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('selectedBusinessId');
    localStorage.removeItem('selectedBusinessName');
    localStorage.removeItem('fetch_user_check');
    
    return { success: false, error };
  }
};